module.exports = __webpack_public_path__ + "static/img/2023_9_8_14.2011affe.2011aff.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/2023_9_8_14.2011affe.png
// module id = syJM
// module chunks = 0